import { SUPPORT_SECTION_TRANSLATION_KEY } from '../constants';

export default {
  [SUPPORT_SECTION_TRANSLATION_KEY]: {
    SUPPORT_SECTION_TITLE: 'Precisa de ajuda?',
    SUPPORT_SECTION_DESCRIPTION:
      'Estamos aqui para ajudar! Escolha o tipo de suporte segundo o que deseja solucionar.',
  },
};
